import {
  LIST_ERPS_INIT,
  LIST_ERPS_SUCCESS,
  CREATE_ERP_INIT,
  CREATE_ERP_SUCCESS,
  UPDATE_ERP_INIT,
  UPDATE_ERP_SUCCESS,
  DELETE_ERP_INIT,
  DELETE_ERP_SUCCESS,
  ADD_ERP_VERSAO_INIT,
  ADD_ERP_VERSAO_SUCCESS,
  ERPS_ERROR_MSG,
  CLEAR_FLAGS_ERPS
} from '../actionTypes';
import { IErp } from 'src/integracoes/servicos/mongo-atlas/modelos/IErp';

const INIT_STATE = {
  erps: [] as IErp[],
  loading: false,
  loadingSave: false,
  loadingAddVersao: false,
  isUpdated: false,
  isVersaoAdded: false,
  isError: false,
  msg: ''
};

export default (state = INIT_STATE, action: any) => {
  switch (action.type) {
    case LIST_ERPS_INIT:
      return { ...state, loading: true, isError: false, msg: '' };
    case LIST_ERPS_SUCCESS: {
      const { erps } = action.payload;
      return { ...state, loading: false, erps };
    }
    case CREATE_ERP_INIT:
      return { ...state, loadingSave: true, isUpdated: false, isError: false, msg: '' };
    case CREATE_ERP_SUCCESS: {
      const { erp } = action.payload;
      return { ...state, loadingSave: false, isUpdated: true, erps: [...state.erps, erp] };
    }
    case UPDATE_ERP_INIT:
      return { ...state, loadingSave: true, isUpdated: false, isError: false, msg: '' };
    case UPDATE_ERP_SUCCESS: {
      const { erp } = action.payload;
      return {
        ...state,
        loadingSave: false,
        isUpdated: true,
        erps: state.erps.map((e) => (e.id === erp.id ? erp : e))
      };
    }
    case DELETE_ERP_INIT:
      return { ...state, loadingSave: true, isUpdated: false, isError: false, msg: '' };
    case DELETE_ERP_SUCCESS: {
      const { id } = action.payload;
      return { ...state, loadingSave: false, isUpdated: true, erps: state.erps.filter((e) => e.id !== id) };
    }
    case ADD_ERP_VERSAO_INIT:
      return { ...state, loadingAddVersao: true, isVersaoAdded: false, isError: false, msg: '' };
    case ADD_ERP_VERSAO_SUCCESS: {
      const { erp } = action.payload;
      return {
        ...state,
        loadingAddVersao: false,
        isVersaoAdded: true,
        erps: state.erps.map((e) => (e.id === erp.id ? erp : e))
      };
    }
    case ERPS_ERROR_MSG: {
      const msg = typeof action.payload === 'string' ? action.payload : action.payload?.msg;
      return { ...state, loading: false, loadingSave: false, isError: true, msg };
    }
    case CLEAR_FLAGS_ERPS:
      return { ...state, isUpdated: false, isError: false, loadingSave: false, loadingAddVersao: false, isVersaoAdded: false, msg: '' };
    default:
      return { ...state };
  }
};
